import React from "react";
function TimelineStores()
{
    return(
        <>
                {/* <!-- Store locations --> */}
        <section class="flat-spacing-12">
            <div class="container">
                <div class="tf-timeline-wrap position-relative">
                    <div class="tf-timeline-line"></div>
                    <div class="tf-timeline-item z-2 position-relative">
                        <div class="tf-timeline-inner d-flex align-items-center justify-content-between tf-timeline-content-end">
                            <span class="tf-timeline-time">1980</span>
                            <div class="tf-timeline-content">
                                <div class="tf-timeline-label fw-7">PHASE 1</div>
                                <h4 class="tf-timeline-title">Inception and Brand Establishment</h4>
                                <div class="tf-timeline-description">Inception, in the context of brand establishment, refers to the initial phase of creating and introducing a brand to the market. It involves laying down the foundational elements that will define the brand's identity, values, and positioning in the minds of consumers.</div>
                            </div>
                            <div class="tf-timeline-image">
                                <img class="lazyload" src="/assets/images/shop/file/timeline1.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="tf-timeline-item z-2 position-relative">
                        <div class="tf-timeline-inner d-flex align-items-center justify-content-between">
                            <span class="tf-timeline-time">2000</span>
                            <div class="tf-timeline-content">
                                <div class="tf-timeline-label fw-7">PHASE 2</div>
                                <h4 class="tf-timeline-title">Debut Collection and Market Entry</h4>
                                <div class="tf-timeline-description">Entering the market with a debut collection requires careful planning, creativity, and perseverance. By following these steps and staying true to your vision, you can increase your chances of success in the fashion industry.</div>
                            </div>
                            <div class="tf-timeline-image">
                                <img class="lazyload" data-src="/assets/images/shop/file/timeline2.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="tf-timeline-item z-2 position-relative">
                        <div class="tf-timeline-inner d-flex align-items-center justify-content-between tf-timeline-content-end">
                            <span class="tf-timeline-time">2010</span>
                            <div class="tf-timeline-content">
                                <div class="tf-timeline-label fw-7">PHASE 3</div>
                                <h4 class="tf-timeline-title">Growth and Recognition</h4>
                                <div class="tf-timeline-description">During the Growth and Recognition phase of a brand's journey, several key elements come into play to propel its expansion and solidify its position in the market. Here's an outline of what typically occurs during this phase</div>
                            </div>
                            <div class="tf-timeline-image">
                                <img class="lazyload" data-src="/assets/images/shop/file/timeline3.png" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="tf-timeline-item z-2 position-relative">
                        <div class="tf-timeline-inner d-flex align-items-center justify-content-between">
                            <span class="tf-timeline-time">2024</span>
                            <div class="tf-timeline-content">
                                <div class="tf-timeline-label fw-7">PHASE 4</div>
                                <h4 class="tf-timeline-title">Sustainable Initiatives</h4>
                                <div class="tf-timeline-description">Sustainable initiatives play a crucial role in the growth and development of a brand, especially in today's environmentally conscious and socially responsible market landscape. Here are some examples of sustainable initiatives that brands may undertake</div>
                            </div>
                            <div class="tf-timeline-image">
                                <img class="lazyload" data-src="/assets/images/shop/file/timeline4.png" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- /Store locations --> */}

        </>
    )
}
export default TimelineStores;